import React, { useEffect, useRef } from "react";
import UploadIcon from "../../../assets/Icons/UploadIcon";
import * as XLSX from "xlsx";
import { useState } from "react";
import ExCheckBox from "../../../components/basic-components/ExCheckBox";
//import generatePDF from "react-to-pdf";
import DownloadIcon from "../../../assets/Icons/DownloadIcon";
//import Payslip from "./Payslip";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { getCompanyDetail } from "../../../slices/companySlice";
import moment from "moment";
import * as constant from "../../../constant";
import Employee from "../employeeProfile/Employee";

function numberToWords(num) {
  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  function inWords(n) {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000)
      return (
        a[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 ? " " + inWords(n % 100) : "")
      );
    if (n < 100000)
      return (
        inWords(Math.floor(n / 1000)) +
        " Thousand" +
        (n % 1000 ? " " + inWords(n % 1000) : "")
      );
    if (n < 10000000)
      return (
        inWords(Math.floor(n / 100000)) +
        " Lakh" +
        (n % 100000 ? " " + inWords(n % 100000) : "")
      );
    return (
      inWords(Math.floor(n / 10000000)) +
      " Crore" +
      (n % 10000000 ? " " + inWords(n % 10000000) : "")
    );
  }

  const [rupees, paise] = num.toFixed(2).split(".").map(Number);
  let result = "";
  if (rupees > 0) result += inWords(rupees) + " Rupees";
  if (paise > 0)
    result += (rupees > 0 ? " and " : "") + inWords(paise) + " Paise";
  return result || "Zero Rupees";
}

const Payslip = React.forwardRef(
  ({ employee, company, companyLogoImage }, ref) => (
    <div
      ref={ref}
      className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-xl text-sm font-sans"
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center ">
          <img
            src={companyLogoImage}
            alt="Company Logo"
            className="h-24 w-auto object-contain"
            crossOrigin="anonymous"
          />
        </div>
        <div>
          <h1 className="text-center text-xl font-semibold mb-4">
            {company?.title}
          </h1>
          <p className="text-center">
            Office no 903-904, B wing, Arihant Aura, Thane belapur road. Navi
            Mumbai 400705
          </p>
        </div>
        <div></div>
      </div>

      <h2 className="text-center text-lg font-medium mb-4">
        Pay slip for the month of {employee["Date"]}
      </h2>

      <table className="w-full table-fixed border border-exgray-400 mb-6 text-sm">
        <tbody>
          {[
            [
              "Employee Code",
              employee["Emp Code"],
              "Employee Name",
              employee["Emp Name"],
            ],
            ["Division", employee["Division"], "Category", "Individual"],
            [
              "Grade",
              employee["Bands"] || "NA",
              "Location",
              employee["Location"] || "NA",
            ],
            [
              "Date Of Joining",
              employee["DOJ"] || "NA",
              "Department",
              employee["Department"] || "NA",
            ],
            [
              "Designation",
              employee["Designation"],
              "PAN No.",
              employee["PAN No."],
            ],
            [
              "PF Account No.",
              employee["PF Account No."],
              "ESIC Number",
              employee["ESIC Number"],
            ],
            [
              "UAN Number",
              employee["UAN Number"],
              "Bank Account No.",
              employee["Bank Account No."],
            ],
            [
              "Bank Name",
              employee["Bank Name"],
              "Total Days In Month",
              employee["Days in Month"],
            ],
            [
              "Paid",
              employee["Total Working Days"],
              "Leave Without Pay",
              employee["LOP"],
            ],
          ].map((row, index) => (
            <tr key={index}>
              <td className="border border-exgray-400 px-3 pb-4 text-base font-medium text-gray-700 w-1/6 items-center bg-gray-200">
                {row[0]}
              </td>
              <td className="border border-exgray-400 px-3 pb-4 text-gray-800 w-1/3 text-base items-center font-bold">
                {row[1] || "—"}
              </td>
              <td className="border border-exgray-400 px-3 pb-4 text-base font-medium text-gray-700 w-1/6 items-center bg-gray-200">
                {row[2]}
              </td>
              <td className="border border-exgray-400 px-3 pb-4 text-gray-800 w-1/3 text-base items-center font-bold">
                {row[3] || "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <table className="w-full border border-exgray-400 text-left mb-6">
        <thead className="bg-gray-200">
          <tr>
            <th className="border border-exgray-400 px-3 pb-4">Earnings</th>
            <th className="border border-exgray-400 px-3 pb-4">Actual</th>
            <th className="border border-exgray-400 px-3 pb-4">Amount</th>
            <th className="border border-exgray-400 px-3 pb-4">Arrear/Adj</th>
            <th className="border border-exgray-400 px-3 pb-4">Deductions</th>
            <th className="border border-exgray-400 px-3 pb-4">Amount</th>
            <th className="border border-exgray-400 px-3 pb-4">Arrear/Adj</th>
          </tr>
        </thead>
        <tbody>
          {[
            [
              "Basic Salary",
              `${employee["Basic Actual"].toLocaleString()}`,
              `${employee["Basic Amount"].toLocaleString()}`,
              "0.00",
              "Professional Tax",
              `${employee["PT"].toLocaleString()}`,
              "0.00",
              "0.00",
            ],
            [
              "House Rent Allowance",
              `${employee["HRA"].toLocaleString()}`,
              `${(employee["Basic Amount"] * 0.5).toLocaleString()}`,
              "0.00",
              "Provident Fund",
              `${employee["Employee PF"].toLocaleString()}`,
              "0.00",
            ],
            [
              "Statutory Bonus",
              `${employee["Statutory Bonus"].toLocaleString()}`,
              `${Math.round(
                employee["Basic Amount"] * 0.0833
              ).toLocaleString()}`,
              "0.00",
              "TDS",
              `${employee["Income Tax (TDS)"].toLocaleString()}`,
              "0.00",
            ],
            [
              "Medical Allowance",
              `${employee["Medical Allowance"].toLocaleString()}`,
              `${employee["Medical Allowance"].toLocaleString()}`,
              "0.00",
              "Employee ESIC @ 0.75%",
              `${employee["Employee ESIC @ 0.75%"].toLocaleString()}`,
              "0.00",
            ],
            [
              "Residual Choice Pay",
              `${employee["Residual Choice Pay"].toLocaleString()}`,
              `${Math.round(
                employee["Monthly Fixed Component"] -
                  employee["Basic Amount"] -
                  employee["Basic Amount"] * 0.5 -
                  employee["Basic Amount"] * 0.0833 -
                  employee["Medical Allowance"]
              ).toLocaleString()}`,
              "0.00",
              "Loan Repayments",
              `${employee["Loan Repayments"].toLocaleString()}`,
              "0.00",
            ],
            [
              "Incentives",
              `${employee["Incentives"].toLocaleString()}`,
              `${employee["Incentives"].toLocaleString()}`,
              "0.00",
              "Other Deductions",
              `${employee["Other Deductions"].toLocaleString()}`,
              "0.00",
            ],
            [
              "Deputation Allowance",
              `${employee["Deputation Allowance"].toLocaleString()}`,
              `${employee["Deputation Allowance"].toLocaleString()}`,
              "0.00",
              "MLWF (employee)",
              `${employee["MLWF (employee)"].toLocaleString()}`,
              "0.00",
            ],
            [
              "Leave Encashment",
              `${employee["Leave Encashment"].toLocaleString()}`,
              `${employee["Leave Encashment"].toLocaleString()}`,
              "0.00",
              "",
              "",
              "",
            ],
            [
              "Performance bonus",
              `${employee["Performance bonus"].toLocaleString()}`,
              `${employee["Performance bonus"].toLocaleString()}`,
              "0.00",
              "",
              "",
              "",
            ],
          ].map((row, i) => {
            const pairs = [];
            for (let j = 0; j < row.length; j += 4) {
              const label = row[j];
              const value = row[j + 1];
              const numValue = parseFloat(value);
              if (
                label &&
                value &&
                !isNaN(numValue) &&
                numValue !== 0 &&
                j < 4
              ) {
                pairs.push([label, value, row[j + 2], row[j + 3]]);
              } else if (label && value && !isNaN(numValue) && numValue !== 0) {
                pairs.push([label, value, row[j + 2]]);
              } else if (
                row[0] &&
                !isNaN(parseFloat(row[1])) &&
                parseFloat(row[1]) !== 0 &&
                label &&
                numValue == 0 &&
                j > 3
              ) {
                pairs.push(["", "", ""]);
              }
            }

            if (pairs.length === 0) return null;

            return (
              <tr key={i}>
                {pairs.map(([label, value, value1, value2], j) => (
                  <React.Fragment key={j}>
                    <td className="border border-exgray-400 text-base px-3 pb-4 font-medium">
                      {label}
                    </td>
                    <td className="border border-exgray-400 text-base px-3 pb-4">
                      {value}
                    </td>
                    <td className="border border-exgray-400 text-base px-3 pb-4">
                      {value1}
                    </td>
                    {value2 && (
                      <td className="border border-exgray-400 text-base px-3 pb-4">
                        {value2}
                      </td>
                    )}
                  </React.Fragment>
                ))}
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr className="font-semibold bg-gray-200 border-t border-b border-exgray-400">
            <td className="border text-base border-exgray-400 px-3 pb-4">
              Gross Salary
            </td>
            <td className="border text-base border-exgray-400 px-3 pb-4">
              {employee["Monthly Fixed Salary"].toLocaleString()}
            </td>
            <td className="border text-base border-exgray-400 px-3 pb-4">
              {employee["Monthly Fixed Component"].toLocaleString()}
            </td>
            <td className="border text-base border-exgray-400 px-3 pb-4">
              0.00
            </td>
            <td className="border text-base border-exgray-400 px-3 pb-4">
              Gross Deduction
            </td>
            <td className="border text-base  border-exgray-400 px-3 pb-4">
              {employee["Total deductions"].toLocaleString()}
            </td>
            <td className="border border-exgray-400 text-base px-3 pb-4">
              0.00
            </td>
          </tr>
          <tr className="font-semibold bg-gray-200">
            <td className="border text-base border-exgray-400 px-3 pb-4">
              Net Salary
            </td>
            <td className="border border-exgray-400 px-3 pb-4"></td>
            <td className="border text-base border-exgray-400 px-3 pb-4">
              {(
                employee["Monthly Fixed Component"] -
                employee["Total deductions"]
              ).toLocaleString()}
            </td>
            <td className="border border-exgray-400 px-3 pb-4"></td>
            <td className="border border-exgray-400 px-3 pb-4"></td>
            <td className="border border-exgray-400 px-3 pb-4"></td>
          </tr>
        </tfoot>
      </table>

      <div className="text-lg font-medium mb-2">
        Net Salary: ₹{" "}
        {employee[
          "Net pay (amount that would reflect in payslip)"
        ].toLocaleString()}{" "}
        Only
      </div>
      <div className="text-lg font-medium mb-2">
        In words:{" "}
        {numberToWords(
          employee["Net pay (amount that would reflect in payslip)"]
        )}
        .
      </div>
      <p className="text-gray-800 text-center text-base font-medium mt-6">
        This is a system generated salary slip and does not require signature or
        stamp.
      </p>
    </div>
  )
);

const PayslipDashboard = () => {
  const hiddenFileInput = useRef(null);
  const [jsonData, setJsonData] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const dispatch = useAppDispatch();
  const loginUserDetails = useAppSelector(
    (state) => state.company.memberDetails
  );
  const loginSelector = useAppSelector((state) => state.login);

  useEffect(() => {
    dispatch(getCompanyDetail({ id: loginUserDetails?.companyId }));
  }, [loginUserDetails?.companyId]);

  const companySelector = useAppSelector(
    (state) => state.company.companyDetails
  );

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const ref = useRef();

  function excelDateToJSDate(serial) {
    const utc_days = Math.floor(serial - 25569); // Excel to Unix epoch (Jan 1, 1970)
    const utc_value = utc_days * 86400; // seconds
    return new Date(utc_value * 1000); // convert to ms
  }

  const handleChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const workbook = XLSX.read(bstr, { type: "binary" });

      // Assume the first sheet
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert to JSON
      let data = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      data = data.map((row) => {
        const hra = row["Basic Actual"] * 0.5;
        const bonus = row["Basic Actual"] * 0.0833;
        const basic = parseFloat(row["Basic Actual"]);
        const medical = parseFloat(row["Medical Allowance"]);
        const total = hra + bonus + basic + medical;
        const monthlyFixedComponent =
          (row["Monthly Fixed Salary"] * row["Total Working Days"]) /
          row["Days in Month"];
        const residualAllowance =
          parseFloat(row["Monthly Fixed Salary"]) - total;
        const gross =
          basic +
          hra +
          bonus +
          medical +
          residualAllowance +
          row["Other allowance"];
        const CTC = gross + +parseFloat(row["Employee ESIC @ 0.75%"]);
        const totalDeductions = //
          parseFloat(row["PF @13%"]) +
            parseFloat(row["EmployerESIC @ 3.25%"]) +
            parseFloat(row["Employee ESIC @ 0.75%"]) +
            parseFloat(row["Employee PF"]) +
            parseFloat(row["Loan Repayments"]) +
            parseFloat(row["PT"]) +
            parseFloat(row["Income Tax (TDS)"]) ||
          0 + parseFloat(row["Other Deductions"]) ||
          0 + parseFloat(row["MLWF (employee)"]) ||
          0;

        const totalAdditions =
          row["Performance bonus"] ||
          0 + row["Leave Encashment"] ||
          0 + row["Deputation Allowance"] ||
          0;

        const netPay = monthlyFixedComponent - totalDeductions;

        const date = moment(excelDateToJSDate(row["Date"])).format(
          "MMMM - YYYY"
        );
        const doj = moment(excelDateToJSDate(row["DOJ"])).format("DD/MM/YYYY");

        return {
          ...row,
          ["DOJ"]: doj,
          ["Monthly Fixed Component"]: Math.round(monthlyFixedComponent), // Updates the existing Age column
          ["HRA"]: Math.round(hra), // Example calculation for HRA
          ["Statutory Bonus"]: Math.round(bonus), // Example calculation for Statutory Bonus
          ["Residual Choice Pay"]: Math.round(residualAllowance), // Example calculation for Residual Choice Pay
          ["Gross"]: Math.round(gross),
          ["CTC"]: Math.round(CTC), // Example calculation for CTC
          ["Total deductions"]: Math.round(totalDeductions), // Example calculation for Total deductions
          ["Net pay (amount that would reflect in payslip)"]:
            Math.round(netPay), // Example calculation for Net pay
          ["Date"]: date, // Format date
        };
      });

      setJsonData(data);
    };
    reader.readAsBinaryString(file);
  };

  const handleCheckboxChange = (employeeId) => {
    let selected_emplyee = selectedEmployees;
    if (selected_emplyee.includes(employeeId)) {
      selected_emplyee = selected_emplyee.filter((id) => id !== employeeId);
    } else {
      selected_emplyee.push(employeeId);
    }
    setSelectedEmployees([...selected_emplyee]);
  };

  const handleSelectAllCheckboxes = () => {
    if (jsonData.length === 0) return;
    const allEmployeeIds = jsonData.map((row) => row["Emp Code"]);
    if (selectedEmployees.length === allEmployeeIds.length) {
      setSelectedEmployees([]);
    } else {
      setSelectedEmployees(allEmployeeIds);
    }
  };

  const convertToBase64 = async (url) => {
    const response = await fetch(url, { mode: "cors" });
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const [companyLogoImage, setCompanyLogoImage] = useState("");

  useEffect(() => {
    getBase64Image();
  }, []);

  const getBase64Image = async () => {
    if (companySelector?.profileImage) {
      const companyLogoImage = `${constant.baseUrl}/${companySelector.profileImage}?t=${loginSelector?.session?.token}`;
      const base64 = await convertToBase64(companyLogoImage);
      setCompanyLogoImage(base64);
    }
  };

  const generatePDFForEach = async () => {
    let employeesList = jsonData.filter((emp) =>
      selectedEmployees.includes(emp["Emp Code"])
    );

    for (const emp of employeesList) {
      const wrapper = document.createElement("div");
      wrapper.style.position = "absolute";
      wrapper.style.left = "-9999px";
      document.body.appendChild(wrapper);

      const tempRef = React.createRef();
      const el = (
        <Payslip
          ref={tempRef}
          employee={emp}
          company={companySelector}
          companyLogoImage={companyLogoImage}
        />
      );
      const reactEl = React.cloneElement(el, { ref: tempRef });
      wrapper.appendChild(document.createElement("div"));

      const root = createRoot(wrapper.firstChild as Element);
      root.render(reactEl);

      await new Promise((resolve) => setTimeout(resolve, 500)); // Allow rendering time

      const canvas = await html2canvas(wrapper.firstChild, {
        useCORS: true,
        allowTaint: false,
        scale: 2,
      });
      const imgData = canvas.toDataURL("image/jpeg");
      const date = moment(emp["Date"]).format("MMMM YYYY");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(
        `${emp["Emp Name"].replace(/\s+/g, "_")}_${date.replace(
          /\s+/g,
          "_"
        )}_Payslip.pdf`
      );

      document.body.removeChild(wrapper);
      root.unmount();
    }
  };

  const generateSinglePDF = async (employeeData) => {
    const wrapper = document.createElement("div");
    wrapper.style.position = "absolute";
    wrapper.style.left = "-9999px";
    document.body.appendChild(wrapper);

    const date = moment(employeeData["Date"]).format("MMMM YYYY");

    const tempRef = React.createRef();
    const el = (
      <Payslip
        ref={tempRef}
        employee={employeeData}
        company={companySelector}
        companyLogoImage={companyLogoImage}
      />
    );
    const reactEl = React.cloneElement(el, { ref: tempRef });
    wrapper.appendChild(document.createElement("div"));

    const root = createRoot(wrapper.firstChild as Element);
    root.render(reactEl);

    await new Promise((resolve) => setTimeout(resolve, 500)); // Allow rendering time

    const canvas = await html2canvas(wrapper.firstChild, {
      useCORS: true,
      allowTaint: false,
      scale: 2,
    });
    const imgData = canvas.toDataURL("image/jpeg");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(
      `${employeeData["Emp Name"]?.replace(/\s+/g, "_")}_${date?.replace(
        /\s+/g,
        "_"
      )}_Payslip.pdf`
    );

    document.body.removeChild(wrapper);
    root.unmount();
  };

  return (
    <>
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-medium">Generate Payslip</h1>
        <div className="flex items-center space-x-4">
          {selectedEmployees.length > 0 && (
            <button
              onClick={() => generatePDFForEach()}
              className="px-4 py-2 bg-blue-600 text-white rounded"
            >
              Generate PDF
            </button>
          )}
          <div
            onClick={() => handleClick()}
            className="flex items-center justify-center px-5"
          >
            <h1 className="text-secondary-500 font-medium text-xl px-2 underline">
              Upload Excel File
            </h1>
            <UploadIcon color="#0A65CC" height="30" width="30" />
          </div>
        </div>
      </div>
      <input
        type="file"
        onChange={(event) => handleChange(event)}
        ref={hiddenFileInput}
        style={{ display: "none" }} // Make the file input element invisible
      />
      <div>
        {jsonData.length > 0 && (
          <table className="min-w-full mt-5 border">
            <thead className="bg-secondary-500">
              <tr>
                <th className="px-4 text-exwhite-100 text-nowrap text-sm font-medium">
                  <ExCheckBox
                    className="text-exwhite-100"
                    checked={selectedEmployees.length === jsonData.length}
                    onChange={() => handleSelectAllCheckboxes()}
                    name={undefined}
                    title={undefined}
                  />
                </th>
                <th className="px-4 py-2 text-exwhite-100 text-nowrap text-sm font-medium">
                  Sr. No.
                </th>
                <th className="px-4 py-2 text-exwhite-100 text-nowrap text-sm font-medium">
                  Download
                </th>
                {Object.keys(jsonData[0]).map((key) => (
                  <th
                    key={key}
                    className="px-4 py-2 text-left text-sm font-medium text-exwhite-100 text-nowrap"
                  >
                    {key}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {jsonData.map((row, index) => (
                <tr key={index} className="hover:bg-gray-100">
                  <td className="px-4 border-b">
                    <ExCheckBox
                      className="text-exwhite-100"
                      checked={selectedEmployees.includes(row["Emp Code"])}
                      onChange={() => handleCheckboxChange(row["Emp Code"])}
                      name={row["Emp Code"]}
                      title={undefined}
                    />
                  </td>
                  <td className="px-4 border-b py-4">
                    <h1 className="text-sm text-gray-600">{index + 1}</h1>
                  </td>
                  <td className="px-4 border-b py-4">
                    <div
                      onClick={() => generateSinglePDF(row)}
                      className="text-sm text-gray-600 cursor-pointer"
                    >
                      <DownloadIcon width="20" height="20" />
                    </div>
                  </td>
                  {Object.values(row).map((value, idx) => (
                    <td
                      key={idx}
                      className="px-4 py-2 border-b text-sm text-gray-600"
                    >
                      <h1>{value}</h1>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};

export default PayslipDashboard;

// const EmployeePayslip = ({ employeeData }) => {
//   const ref = useRef();

//   const data = {
//     employeeCode: employeeData["Emp Code"],
//     employeeName: employeeData["Emp Name"],
//     division: employeeData["Division"],
//     category: employeeData["Category"],
//     grade: employeeData["Grade"],
//     branch: employeeData["Branch"],
//     location: employeeData["Location"],
//     dateOfJoining: employeeData["Date Of Joining"],
//     monthYear: employeeData["Month Year"],
//     earnings: [
//       { name: "Basic", amount: employeeData["Basic"] },
//       { name: "HRA", amount: employeeData["HRA"] },
//       { name: "Statutory Bonus", amount: employeeData["Statutory Bonus"] },
//       { name: "Medical Allowance", amount: employeeData["Medical Allowance"] },
//       {
//         name: "Residual Choice Pay",
//         amount: employeeData["Residual Choice Pay"],
//       },
//     ],
//     deductions: [
//       { name: "PF", amount: employeeData["Employee PF"] },
//       { name: "ESIC", amount: employeeData["Employee ESIC @ 0.75%"] },
//       { name: "Loan Repayments", amount: employeeData["Loan Repayments"] },
//       { name: "PT", amount: employeeData["PT"] },
//     ],
//     grossSalary: employeeData["Gross"],
//     grossDeduction: employeeData["Total deductions"],
//     netSalary: employeeData["Net pay (amount that would reflect in payslip)"],
//     netPayWords: employeeData["Net Pay Words"],
//   };

//   return (
//     <div>
//       <button
//         onClick={() => generatePDF(ref, { filename: `${}` })}
//         className="px-2 py-1 bg-green-600 text-white rounded text-xs"
//       >
//         Generate Pdf
//       </button>

//       <div
//         ref={ref}
//         style={{ padding: "20px", width: "600px", background: "white" }}
//       >
//
//       </div>
//     </div>
//   );
// };
